import React from "react";
import "./RedirectToForm.css";

const RedirectToForm = () => {
  return (
    <div className="RedirectToForm animated-fade-in">
      <div className="form-header">
        <h1>kickstart your career journey with SkillsHap</h1>
      </div>

      <div className="form-container hover-glow">
        <iframe
          title="SkillsHap Form"
          src="https://forms.gle/B9ZHm3azzM9suzsN9"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default RedirectToForm;
